import { safeHTML } from '../../../../../../utils/safeHTML';
import content from '../../../constants/content';
import { useTranslation } from '../../../../../../translations';
import React from 'react';
import Item from '../Item/Item';

const { modal } = content;

export default function WinnersList({ status, prizes }) {
  const { listTitle } = modal[status];
  const { t } = useTranslation();

  return (
    <div className={'drawing-result-modal__list'}>
      {listTitle && <h3 className={'drawing-result-modal__list-title'}>{safeHTML(t(listTitle))}</h3>}
      <div className={'drawing-result-modal__list-items'}>
        {prizes.map((item, index) => (
          <Item key={index} {...item} />
        ))}
      </div>
    </div>
  );
}
